import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {LogoBox} from "./logo-box/logo-box.component";
import {UserMenuMobile} from "./user-menu/user-menu-mobile.component";
import {UserMenuPc} from "./user-menu/user-menu-pc.component";
import { UserMenuCloseIconBox } from "./close-button/boxes/user-menu-close-icon.box";
import { MobileMenuHeaderBox } from "../main-nav/boxes/mobile/mobile-menu-header.box";
import { FlexGrowItemBox, FlexContainerBox } from "../../themes/architecture/css-helpers/flex";
import { MobileBackBox } from "../main-nav/boxes/mobile/back/mobile-back.box";
import { MobileBackLabelBox } from "../main-nav/boxes/mobile/back/mobile-back-label.box";

//import {FreeplayDetails} from "./freeplay-details/freeplay-details.component";
import {FreePlayContainerComponent} from "../free-play/free-play-container.component";
import {UserMenuRootBox} from "./user-menu/boxes/root/user-menu-root.box";
import {UserMenuWrapperBox} from "./user-menu/boxes/wrapper/user-menu-wrapper.box";
import {UserMenuHolderBox} from "./user-menu/boxes/holder/user-menu-holder.box";
import {CyClass} from "../../../common/cy-classes";
import classNames from "classnames";
import {USER_MENU_OPEN} from "../../themes/css-global-classes";


@observer
export class UserMenu extends OrbitComponent {

  private holderRef = React.createRef<HTMLDivElement>();

  private _renderUserMenuHeader() {

    if (this.services.device.isMobile) {
      return (
        <MobileMenuHeaderBox>
          <FlexGrowItemBox flexBasis="33%">
            {this._renderMobileBackButton()}
          </FlexGrowItemBox>
          <FlexGrowItemBox flexBasis="33%">
            <LogoBox onClick={() => this._closeMenu()}/>
          </FlexGrowItemBox>
          <FlexGrowItemBox flexBasis="33%">
            <FlexContainerBox justifyContent="flex-end">
              <UserMenuCloseIconBox className="cy-user-menu-close-btn" onClick={() => this._closeMenu()} />
            </FlexContainerBox>
          </FlexGrowItemBox>
        </MobileMenuHeaderBox>
      );
    }

    return null;
  }

  render() {
    if(!this.services.user.isAuthorized) {
      return null;
    }

    const cssClasses = classNames(CyClass('cy-user-menu'), {
      [USER_MENU_OPEN]: this.services.userMenu.isOpen
    });

    return (
      <UserMenuRootBox className={cssClasses} zIndex={this.services.userMenu.zIndex}>
        <UserMenuWrapperBox>
          {this._renderUserMenuHeader()}
          <UserMenuHolderBox ref={this.holderRef}>
            {this._renderMenuContents()}
          </UserMenuHolderBox>
        </UserMenuWrapperBox>
      </UserMenuRootBox>
    );
  }

  private _renderMobileBackButton() {
    if(!this.services.device.isMobile)
      return null;
    if(!this.services.userMenu.isRewardsInfo)
      return null;

    const BackIcon = this.services.theme.currentTheme.icons.backIcon;
    return (
      <MobileBackBox className="cy-rewards-mobile-back-icon" onClick={this._closeMenu}>
        <BackIcon />
        <MobileBackLabelBox>{this.services.translation.translate("BACK")}</MobileBackLabelBox>
      </MobileBackBox>
    );
  }

  private _renderMenuContents() {
    if(this.services.userMenu.isRewardsInfo) {
      //return <FreeplayDetails/>;
      return (<FreePlayContainerComponent/>);
    } else if(this.services.device.isMobile) {
      return <UserMenuMobile/>;
    } else {
      return <UserMenuPc closeMenu={() => this._closeMenu()}/>;
    }
  }

  private _closeMenu = () => {
    if (this.holderRef.current) {
      this.holderRef.current.scrollTop = 0;
    }
    this.services.userMenu.closeMenu();
  }
}
